import { combineReducers } from 'redux';
import {labelsReducer} from './labels/reducer';
import {generalReducer} from './general/reducer';
import {aiReducer} from './ai/reducer';
import {notificationsReducer} from './notifications/reducer';
import inspectionReducer from './Inspection/reducer';

export const rootReducer = combineReducers({
    general: generalReducer,
    labels: labelsReducer,
    tags: labelsReducer,
    ai: aiReducer,
    notifications: notificationsReducer,
    inspection: inspectionReducer,

});

export type AppState = ReturnType<typeof rootReducer>;
